/* eslint-disable
    func-names,
    no-param-reassign,
    radix,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const _ = require('lodash');

const CategorizerRuleInputCtrl = function (
  $scope,
  CategorizerRuleCollection,
  CategorizerRule,
  blConfirmService,
  NotificationsService,
  User,
  LedgerCollection,
) {
  this.rules = new CategorizerRuleCollection(this.rulesId);
  this.ledgers = new LedgerCollection(User.getClientId());
  this.isInvalidRule = true;
  this.isLoadingRule = false;
  this.isEditInput = !_.isUndefined(this.ruleId);
  this.editableRule = null;

  this.resetModels = () => (this.input = { priority: 1 });

  this.input = this.resetModels();

  this.oldRulePayload = null;
  this.setEditableInputs = () => {
    if (!this.isEditInput) {
      return;
    }

    this.editableRule = new CategorizerRule({
      id: this.ruleId,
    });

    this.isLoadingRule = true;

    return this.editableRule
      .$fetch()
      .then(response => {
        const rule = response != null ? response.data : undefined;

        this.oldRulePayload = rule;
        _.assignIn(this.input, rule);
        this.input.sourceLedgerAccount = this.ledgers.$findById(this.input.sourceLedgerAccountId);
        this.input.ledger = this.ledgers.$findById(this.input.ledgerId);
      })
      .catch(() =>
        NotificationsService.add('Categorizer rule cannot be edited at this time.', {
          type: 'error',
          length: 2,
        }),
      )
      .finally(() => {
        this.isLoadingRule = false;
      });
  };

  this.isLoadingLedgerOptions = true;
  this.ledgers.$onSet(() => {
    this.ledgerSelect = this.ledgers.getSelectableLedgerAccounts();
    this.sourceLedgerSelect = this.ledgers.getAccounts();
    this.isLoadingLedgerOptions = false;
    return this.setEditableInputs();
  });

  this.checkInvalidRule = () => {
    const isProperAmountFormat = function (value) {
      if (value == null) {
        value = '';
      }
      return /^-?([0-9]*)\.?([0-9]{1,2})?$/.test(value.toString());
    };

    const { vendorContains, ledger, priority } = this.input;

    if (!vendorContains || !(ledger != null ? ledger.id : undefined)) {
      return (this.isInvalidRule = true);
    }

    const minAmount = parseFloat(this.input.minAmount);
    const maxAmount = parseFloat(this.input.maxAmount);
    const isMinValid = isProperAmountFormat(this.input.minAmount);
    const isMaxValid = isProperAmountFormat(this.input.maxAmount);

    if (!isMinValid || !isMaxValid) {
      return (this.isInvalidRule = true);
    }

    if (_.isNumber(minAmount) && _.isNumber(maxAmount) && minAmount > maxAmount) {
      return (this.isInvalidRule = true);
    }

    if (!_.isInteger(priority)) {
      return (this.isInvalidRule = true);
    }

    return (this.isInvalidRule = false);
  };

  this.notify = function (promise, notifyText) {
    return NotificationsService.loader({
      resolve: promise,
      loadingText: `${notifyText.loading} rule...`,
      successText: `Categorizer rule ${notifyText.success}!`,
      failureText: `Categorizer rule ${notifyText.failure} failed.`,
    })
      .then(() => this.rules.$fetch())
      .then(() => {
        this.isInvalidRule = true;

        if (!this.isEditInput) {
          return this.resetModels();
        }
      });
  };

  this.save = () => {
    const clientId = parseInt(User.getClientId());
    const ledgerId = parseInt(this.input.ledger.id);
    const { vendorContains } = this.input;
    const priority = parseInt(this.input.priority);
    const minAmount = parseFloat(this.input.minAmount);
    const maxAmount = parseFloat(this.input.maxAmount);
    const sourceLedgerAccountId =
      this.input.sourceLedgerAccount && parseInt(this.input.sourceLedgerAccount.id);
    const payload = {
      clientId,
      priority,
      ledgerId,
      vendorContains,
      minAmount,
      maxAmount,
      sourceLedgerAccountId,
    };
    _.omitBy(payload, _.isNil); // remove nil props

    if (this.isEditInput) {
      payload.id = parseInt(this.ruleId);

      if (window.heap) {
        window.heap.track('Client Rule Updated', {
          ruleId: payload.id.toString(),
          oldRulePayload: JSON.stringify(this.oldRulePayload),
          updateAt: new Date().toString(),
          newRulePayload: JSON.stringify(payload),
          action: 'Client Rule Updated',
        });
      }

      return this.notify(this.editableRule.$put(payload), {
        loading: 'Updating',
        success: 'edited',
        failure: 'edit',
      });
    }

    const newRule = new CategorizerRule({
      clientId: User.getClientId(),
    });

    return this.notify(newRule.$post(payload), {
      loading: 'Uploading new',
      success: 'added',
      failure: 'upload',
    });
  };

  this.stopEnterPropagation = function (e) {
    if (e.keyCode === 13) {
      // ENTER
      return e.preventDefault();
    }
  };

  this.isLoadingEditableRules = function () {
    return this.isEditInput && this.isLoadingRule;
  };
};

module.exports = CategorizerRuleInputCtrl;
